import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { StandaloneCheckbox } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const Terms = ({ isTermsChecked, onConfirmationCheckboxChange, isFormSubmitted }) => (
  <Content>
    {({
      personalInformationTermsLabel = '',
      personalInformationTermsError = '',
      personalInformationTermsAgreement = ''
    }) => (
      <Field name="personalInformationTermsAgreement" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="agreementwrapper"
            validationMessage={
              isFormSubmitted && !isTermsChecked ? personalInformationTermsError : ''
            }
          >
            <StandaloneCheckbox
              hasError={isFormSubmitted && !isTermsChecked}
              isChecked={isTermsChecked}
              id="agreement"
              labelText={personalInformationTermsLabel}
              onChange={onConfirmationCheckboxChange}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default Terms;
